import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import TopicPageDivider from "../../TopicPage_Divider";
import TopicPageViewsTopicEditors from "../TopicPageViewsTopicEditors";
const TopicPageViewsTopicListDividerWithEditors = (props)=>{
    const { divider , dragProvided , dragSnapshot , navigationItemHelpers , topicId , topicNodeId , context ,  } = props;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TopicPageDivider, {
                divider: divider,
                dragProvided: dragProvided,
                isDragging: dragSnapshot.isDragging,
                navigationItemHelpers: navigationItemHelpers
            }),
            /*#__PURE__*/ _jsx(TopicPageViewsTopicEditors, {
                topicId: topicId,
                topicNodeId: topicNodeId,
                afterItemId: divider.id,
                context: context
            })
        ]
    });
};
export default TopicPageViewsTopicListDividerWithEditors;
